<template>
  <div class="c-light-box">
    <div class="c-light-box__main">
      <!-- -->
      <!-- arrow -->
      <card bg="bright" class="c-light-box__main__card" modifier="lightbox" :parallax="false" :slide-on-mounted="false">
        <template #inner>
          <!-- slot -->
          <light-box-body>
            <light-box-video v-if="isOpen" />
          </light-box-body>
        </template>
        <template #behind> </template>
      </card>
    </div>
  </div>
</template>

<script>
import Card from "components/Card";
import LightBoxBody from "components/LightBox/LightBoxBody";
import LightBoxVideo from "components/LightBox/LightBoxVideo";

export default {
  components: {
    Card,
    LightBoxBody,
    LightBoxVideo
  },
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  beforeDestroy() {
    this.$store.commit("lightBox/RESET_LIGHT_BOX");
  }
};
</script>

<style lang="scss">
.c-light-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  opacity: 1;
  background: $color-lighter;
  &__main {
    &__cross {
    }
    &__card {
      width: 100vw;
      height: 100vh;
      max-width: 100vw; // overwrite child value
    }
  }
}
</style>
